export function floatTimes(x:number,y:number){
    return changeFloatToInt(x)*changeFloatToInt(y)/(Math.pow(10,getPoint(x)+getPoint(y)));
}

function getPoint(x:number){
    let str=x.toString().split('.');
    if(str.length==1)
    return 0;
    else{
        return str[1].length;
    }
}

function changeFloatToInt(x:number){
    let xP=getPoint(x);
    return Math.round((x*Math.pow(10,xP)))
}

export function CheckNumber(value:string){
    if(value==""){
        return 0;
    }
    let split=value.split('.')
    let result="";
    //对第0项做处理，使其不为0开头
    let firstItem=cutFirst(split[0]);

    result+=firstItem;
    if(split.length==1){
        return Number.parseInt(result);
    }else{
        result+='.';
        for(let i=1;i<split.length;i++){
            var numReg = /^[0-9]*$/
            var numRe = new RegExp(numReg)
            if(numRe.test(split[i])){
                result+=split[i]           
            }
        }
        return Number.parseFloat(result);
    }
}

function cutFirst(value:string){
    if(!value.startsWith('0')||value=='0'){
        return value;
    }else{
        value=value.substring(1,value.length);
        return cutFirst(value);
    }
}

export function NumberCut(str:string){
    const regex = /^\d+(\.\d+)?$/;
    if(regex.test(str)){
        if(str.includes('.')){
            let index=str.length-1;
            for(let i=0;i<str.length;i++){
                if(str[str.length-1-i]!='0'){
                    if(str[str.length-1-i]=='.'){
                        index=str.length-i+1;
                    }else{
                        index=str.length-i;
                    }
                    break;
                }
            }
            str=str.substring(0,index);
        }
    }
    return str;
}